import React, { useEffect, useState } from 'react';
import { Box, Container, makeStyles, Toolbar } from '@material-ui/core';
import Page from 'src/components/Page';
import Results from './Results';
import TotalProfit from '../../reports/DashboardView/TasksProgress';
// import config from './../../../config/config.json';
import { store } from '../../../_helpers';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const UserListView = () => {
  const classes = useStyles();
  const [customers, setCustomer] = useState([]);
  const navigate = useNavigate();
  let { user } = store.getState().authentication;
  useEffect(() => {
    if (typeof user === 'undefined') {
      // userActions.logout();
      navigate('/', { replace: true });
    }
    // console.log('data123', user);
    // if (user.type === 'user') {
    fetch(
      process.env.REACT_APP_BASE_URL +
        `/v10/pay/findAll?token=${user?.token}&email=${user?.email}`
    )
      .then(response => response.json())
      .then(data => {
        // console.log('data', data);
        setCustomer(data.results);
      });
    // }
  }, []);

  return (
    <Page className={classes.root} title="Customers">
      <TotalProfit />
      <Container maxWidth={false}>
        <Box mt={3}>
          <Results record={customers} />
        </Box>
      </Container>
    </Page>
  );
};

export default UserListView;
